<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    h2.modal__title Восстановление пароля
    p.modal__text
    .modal__form
      form
        .form
          .form__elem
            .form-elem(
              :class="{'form-elem_error' : fieldsErrors.password1}"
            )
              .form-elem__title Введите новый пароль
              .form-elem__main
                input.input.input_full(
                type="password"
                v-model="fields.password1"
                @input="onInputChange($event, 'password1')"
                )
          .form__elem
            .form-elem(
            :class="{'form-elem_error' : fieldsErrors.password2}"
            )
              .form-elem__title Введите новый пароль еще раз
              .form-elem__main
                input.input.input_full(
                type="password"
                v-model="fields.password2"
                @input="onInputChange($event, 'password2')"
                )
          .form__elem
            .form-elem
              .form-elem__main
                button.button.button_paint-main.button_full(
                @click.prevent="onButtonClick"
                :class="{'loaded-button':isPending}"
                )
                  .button__text Сменить пароль
                .form-elem__error(
                  v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}
    .modal__links.modal-links
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'sign-up')"
        ) Регистрация
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'sign-in')"
        ) Вход на сайт
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "change-password",
  data() {
    return {
      fields: {
        password1: "",
        password2: "",
      },
      fieldsErrors: {
        password1: false,
        password2: false,
      },
      isPending: false,
      errorMessages: {
        password1: "Пароль должен содержать минимум 8 символов",
        password2: "Пароль не совпадает",
      },
      currentErrorMessage: "",
    };
  },
  computed: {
    reset_password_token() {
      return this.$route.query.reset_password_token;
    },
  },
  methods: {
    ...mapActions(["changePassword"]),
    onInputChange(e, field) {
      this.fieldsErrors[field] = false;
      this.currentErrorMessage = "";
    },
    validation() {
      let errors = [];
      if (this.fields.password1.length < 8) {
        errors.push("password1");
      }
      if (this.fields.password2 !== this.fields.password1) {
        errors.push("password2");
      }

      if (errors.length > 0) {
        errors.map((el) => {
          this.fieldsErrors[el] = true;
        });
        this.currentErrorMessage = this.errorMessages[errors[0]];
        return false;
      }
      return true;
    },
    onButtonClick() {
      if (!this.validation()) {
        return;
      }
      this.isPending = true;
      this.changePassword({
        params: {
          reset_token: this.reset_password_token,
        },
        data: {
          password: this.fields.password1,
        },
      }).then((res) => {
        this.isPending = false;
        if (res.status === 200) {
          this.$router.replace({ query: {} });
          this.$emit("changeModalMode", "notification", {
            title: "Пароль изменен",
            text: `Попробуйте войти в учетную запись.`,
          });
        } else if (res.status === 400) {
          this.currentErrorMessage = res.data[0].message;
        }
      });
    },
  },
};
</script>
